<template>
  <div class="uc-homePage">
    <TopHeader code="home" />
    <!-- 轮播图 -->
    <template v-for="plate in plates">
      <section
        class="uc-homeBannerBox1"
        v-if="plate.plate_type == 1"
        :key="plate.id"
      >
        <swiper
          v-if="plate.items && plate.items.length > 0"
          :options="swiperOption"
        >
          <swiper-slide v-for="(item, index2) in plate.items" :key="index2">
            <a href="javascript:;" class="container">
              <img
                :src="item.url"
                :data-item="JSON.stringify(item)"
                onload="loadSlideImg(this)"
                crossorigin="anonymous"
                style="display: none"
              />
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </section>

      <!-- 口碑好课 -->
      <section
        class="container-fluid uc-homePart1"
        v-if="plate.plate_type == 2"
        :key="plate.id"
      >
        <div class="container">
          <div class="row">
            <div class="col-24">
              <div class="g-title">
                <b>{{ plate.name }}</b>
                <router-link
                  :to="{ name: 'Course' }"
                  class="el-icon-more"
                  title="查看更多课程"
                ></router-link>
              </div>
            </div>
          </div>
          <div class="content-empty" v-if="plate.items.length == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>
          <div class="row list">
            <div
              v-for="(item, index2) in plate.items"
              :key="index2"
              class="col-6"
            >
              <div class="item">
                <router-link
                  :to="{ name: 'CourseDetails', params: { id: item.id } }"
                  class="con"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">
                      {{ item.lecturer_name || '无讲师' }}
                      | {{ item.period }}分钟 | {{ item.score }}学分
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--新课速递 -->
      <section
        class="container-fluid uc-homePart1"
        v-if="plate.plate_type == 6"
        :key="`plate:${plate.id}`"
      >
        <div class="container">
          <div class="row">
            <div class="col-24">
              <div class="g-title">
                <b>{{ plate.name }}</b>
                <router-link
                  :to="{ name: 'Course' }"
                  class="el-icon-more"
                  title="查看更多课程"
                ></router-link>
              </div>
            </div>
          </div>
          <div class="content-empty" v-if="plate.items.length == 0">
            <div class="emptyimg-box"></div>
            <p>暂无相关内容</p>
          </div>
          <div class="row list">
            <div
              v-for="(item, index5) in plate.items"
              :key="index5"
              class="col-6"
            >
              <div class="item">
                <router-link
                  :to="{ name: 'CourseDetails', params: { id: item.id } }"
                  class="con"
                >
                  <div class="img-box">
                    <el-image :src="item.cover">
                      <div slot="error" class="image-slot">
                        <img src="../assets/images/default-kc.png" />
                      </div>
                    </el-image>
                  </div>
                  <div class="btm">
                    <el-tooltip
                      placement="top"
                      effect="light"
                      :content="item.name"
                    >
                      <h3>{{ item.name }}</h3>
                    </el-tooltip>
                    <div class="txt">
                      {{ item.lecturer_name || '无讲师' }}
                      | {{ item.period }}分钟 | {{ item.score }}学分
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 培训活动 -->
      <section
        class="container-fluid uc-homePart3"
        v-if="plate.plate_type == 4"
        :key="plate.id"
      >
        <div class="container">
          <div class="row" style="margin-left: 0; margin-right: 5px">
            <div class="col-16 box-left">
              <div class="row">
                <div class="col-24">
                  <div class="g-title">
                    <b v-text="plate.name"></b>
                    <router-link
                      :to="{ name: 'TrainClass' }"
                      class="el-icon-more"
                      title="查看更多培训班"
                    ></router-link>
                  </div>
                </div>
              </div>
              <div class="content-empty" v-if="plate.items.length == 0">
                <div class="emptyimg-box"></div>
                <p>暂无相关内容</p>
              </div>
              <div class="box">
                <template v-for="(item, index2) in plate.items">
                  <div v-if="index2 == banner2Index" :key="index2">
                    <router-link
                      :to="{
                        name: 'TrainClassDetails',
                        params: { id: item.id },
                      }"
                      class="img-box"
                    >
                      <el-image :src="item.cover" fit="cover" class="img">
                        <div slot="error" class="image-slot">
                          <img
                            src="../assets/images/default-hd.png"
                            class="img"
                          />
                        </div>
                      </el-image>
                      <div class="txt">{{ item.name }}</div>
                    </router-link>
                    <div class="uc-homeHdBtm">
                      <div class="info">
                        <div class="item">
                          报名日期：
                          {{
                            item.is_need_sign_up
                              ? item.sign_up_start_time +
                                ' ~ ' +
                                item.sign_up_end_time
                              : '不需要报名'
                          }}
                        </div>
                        <div class="item">
                          培训日期：{{ item.train_start_time }} ~
                          {{ item.train_end_time }}
                        </div>
                        <div class="item">
                          培训人数：
                          {{
                            item.plan_people_number
                              ? item.plan_people_number + '人'
                              : '不限人数'
                          }}
                        </div>
                        <div class="item">
                          培训对象：{{
                            item.train_object ? item.train_object : '--'
                          }}
                        </div>
                        <div class="item">
                          <i class="el-icon-set-up"></i>
                          <span
                            v-html="
                              item.cert_tpl_id == 0
                                ? '无证书'
                                : item.certificate == null
                                ? '未获得证书'
                                : `<a href='${item.certificate.cert_url}' target=_blank>查看证书</a>`
                            "
                          >
                          </span>
                        </div>
                        <div
                          class="item"
                          v-if="item.is_open_topic && item.topic_id > 0"
                        >
                          培训话题：
                          <router-link
                            :to="{
                              name: 'TopicDetails',
                              params: { id: item.topic_id },
                            }"
                            target="_blank"
                          >
                            参与讨论>>
                          </router-link>
                        </div>
                      </div>
                      <div class="intro">
                        <span class="txt1">介绍：</span>
                        {{ item.train_content || '无' }}
                      </div>
                    </div>
                  </div>
                </template>
                <div class="operate" v-if="plate.items.length > 0">
                  <div class="number">
                    {{ banner2Index + 1 }}/{{ plate.items.length }}
                  </div>
                  <div class="right">
                    <button
                      class="uc-btn"
                      hover-class="none"
                      @click="
                        banner2Index == 0
                          ? (banner2Index = plate.items.length - 1)
                          : banner2Index--
                      "
                    >
                      <i class="uc-font uc-prev"></i>
                    </button>
                    <button
                      class="uc-btn"
                      hover-class="none"
                      @click="
                        banner2Index == plate.items.length - 1
                          ? (banner2Index = 0)
                          : banner2Index++
                      "
                    >
                      <i class="uc-font uc-next"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 排行榜 -->
            <div class="col-8 box-right">
              <div class="title"></div>
              <div class="tabHeader">
                <div
                  :class="tab == 'tab1' ? 'item on' : 'item'"
                  @click="tab = 'tab1'"
                  style="border-top-left-radius: 20px"
                >
                  学分榜
                </div>
                <div
                  :class="tab == 'tab2' ? 'item on' : 'item'"
                  @click="tab = 'tab2'"
                  style="border-top-right-radius: 20px"
                >
                  积分榜
                </div>
              </div>
              <div v-show="tab == 'tab1'">
                <div class="list">
                  <div
                    class="item"
                    v-for="(item, index) in studyList"
                    :key="index"
                  >
                    <div class="number" v-if="index == 0">
                      <img src="../assets/images/top1.png" class="uc-icon28" />
                    </div>
                    <div class="number" v-else-if="index == 1">
                      <img src="../assets/images/top2.png" class="uc-icon28" />
                    </div>
                    <div class="number" v-else-if="index == 2">
                      <img src="../assets/images/top3.png" class="uc-icon28" />
                    </div>
                    <div class="number" v-else>
                      {{ index + 1 }}
                    </div>
                    <div class="face-box">
                      <el-avatar
                        shape="square"
                        :src="item.avatar"
                        :alt="item.first_name"
                      >
                        <div slot="default" class="image-slot">
                          <img
                            src="../assets/images/default-js.png"
                            :alt="item.first_name"
                          />
                        </div>
                      </el-avatar>
                    </div>
                    <div class="name">{{ item.first_name }}</div>
                    <div class="number2">{{ item.total_score }}</div>
                  </div>
                </div>
              </div>
              <div v-show="tab == 'tab2'">
                <div class="list">
                  <div
                    class="item"
                    v-for="(item, index) in rankList"
                    :key="index"
                  >
                    <div class="number" v-if="index == 0">
                      <img src="../assets/images/top1.png" class="uc-icon28" />
                    </div>
                    <div class="number" v-else-if="index == 1">
                      <img src="../assets/images/top2.png" class="uc-icon28" />
                    </div>
                    <div class="number" v-else-if="index == 2">
                      <img src="../assets/images/top3.png" class="uc-icon28" />
                    </div>
                    <div class="number" v-else>
                      {{ index + 1 }}
                    </div>
                    <div class="face-box">
                      <el-avatar
                        shape="square"
                        :src="item.avatar"
                        :alt="item.first_name"
                      >
                        <div slot="default" class="image-slot">
                          <img
                            src="../assets/images/default-js.png"
                            :alt="item.first_name"
                          />
                        </div>
                      </el-avatar>
                    </div>
                    <div class="name">{{ item.first_name }}</div>
                    <div class="number2">{{ item.total_integral }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>

    <BottomFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue';
import BottomFooter from '@/components/BottomFooter.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import ColorThief from 'colorthief';
// import 'swiper/css/swiper.css';
import 'swiper/dist/css/swiper.css';

const colorThief = new ColorThief();

export default {
  name: 'Home',
  components: {
    TopHeader,
    BottomFooter,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      plates: [],
      rankList: {},
      studyList: {},
      banner2Index: 0,
      tab: 'tab1',
      swiperOption: {
        loop: true,
        autoplay: 3000,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        onTransitionEnd(mySwiper) {
          mySwiper.startAutoplay();
        },
      },
    };
  },
  created() {
    this.initData();
    window.loadSlideImg = (img) => {
      const item = JSON.parse(img.dataset.item);
      img.addEventListener('click', () => {
        this.clickImage(item);
      });
      const color = colorThief.getColor(img);
      img.parentNode.parentNode.style.backgroundColor = `rgb(${color})`;
      img.style.display = 'block';
    };
  },
  methods: {
    initData() {
      this.getPlates();
      this.getIntegralRank();
      this.getStudyRank();
    },
    async getPlates() {
      const response = await this.$api.home.getPlates();
      this.plates = response.data.data;
    },
    async getIntegralRank() {
      const response = await this.$api.home.getIntegralRank();
      this.rankList = response.data.data;
    },
    async getStudyRank() {
      const response = await this.$api.home.getStudyRank();
      this.studyList = response.data.data;
    },
    // 轮播图跳转
    clickImage(item) {
      switch (item.link_type) {
        // 课程
        case 1:
          if (item.link_id) {
            this.$router.push({
              name: 'CourseDetails',
              params: { id: item.link_id },
            });
          }
          break;
        // 评选活动
        case 9:
          if (item.link_id) {
            this.$router.push({
              name: 'LecturerVote',
              params: { id: item.link_id },
            });
          }
          break;
        // 外部链接
        case 99:
          if (item.link_url) {
            window.open(item.link_url);
          }
          break;
      }
    },
  },
};
</script>
